import company from "./pages/company/routes"
import product from "./pages/product/routes"
import overhead from "./pages/overhead/routes"
import salesForecast from "./pages/sales-forecast/routes"
import customer from "./pages/customer/routes"
import financial from "./pages/financial-model/routes"

export default [
    ...company,
    ...product,
    ...overhead,
    ...salesForecast,
    ...customer,
    ...financial
]


// WEBPACK FOOTER //
// ./src/modules/company/routes.js